import { IIcon } from 'shared/interface';

export const Logo = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '117'} height={height || '82'} viewBox='0 0 117 82' fill='none'>
			<path d='M37.8103 18.125L55.9137 29.7916H37.8103V36.6666H79.1896L37.8103 9.94788V18.125Z' fill='white' />
			<path d='M79.1896 21.875L61.0862 10.2084H79.1896V3.33337H37.8103L79.1896 30.0521V21.875Z' fill='white' />
			<path
				d='M12.16 61H15.42L7.3 75H4.58L1.88 61H4.96L6.6 71.06L12.16 61ZM17.0453 62.7L17.5853 60.08H20.5053L19.9853 62.7H17.0453ZM14.7053 75L16.8653 64.2H19.6453L17.4853 75H14.7053ZM28.3898 64.14H29.3498L28.8098 66.76H27.5698C26.7698 66.76 26.1432 66.9533 25.6898 67.34C25.2365 67.7133 24.9098 68.3067 24.7098 69.12L23.5298 75H20.7498L22.9098 64.2H24.7098L24.9098 65.46C25.8565 64.58 27.0165 64.14 28.3898 64.14ZM40.1181 64.2H42.2781L40.1181 75H38.0581L37.9781 74C36.8715 74.8667 35.6248 75.3 34.2381 75.3C33.2915 75.3 32.4515 75.0933 31.7181 74.68C30.9848 74.2533 30.4181 73.6733 30.0181 72.94C29.6181 72.2067 29.4181 71.3867 29.4181 70.48C29.4181 69.6 29.5848 68.7533 29.9181 67.94C30.2648 67.1267 30.7248 66.4267 31.2981 65.84C31.8848 65.2533 32.5848 64.7867 33.3981 64.44C34.2115 64.08 35.0715 63.9 35.9781 63.9C37.4581 63.9 38.6315 64.4333 39.4981 65.5L40.1181 64.2ZM34.7581 72.66C35.7315 72.66 36.5848 72.2867 37.3181 71.54C38.0515 70.78 38.4181 69.9 38.4181 68.9C38.4181 68.18 38.1848 67.6067 37.7181 67.18C37.2515 66.74 36.6381 66.52 35.8781 66.52C35.3981 66.52 34.9315 66.6267 34.4781 66.84C34.0381 67.04 33.6515 67.3133 33.3181 67.66C32.9981 67.9933 32.7381 68.3933 32.5381 68.86C32.3515 69.3267 32.2581 69.8 32.2581 70.28C32.2581 71 32.4848 71.58 32.9381 72.02C33.3915 72.4467 33.9981 72.66 34.7581 72.66ZM43.3858 75L46.3258 60.32H49.1058L46.1658 75H43.3858ZM59.4741 75.3C58.0607 75.3 56.9341 74.96 56.0941 74.28C55.2541 73.6 54.8341 72.6733 54.8341 71.5C54.8341 71.1667 54.8741 70.8267 54.9541 70.48H57.8541C57.8274 70.6267 57.8141 70.7667 57.8141 70.9C57.8141 71.4467 58.0007 71.88 58.3741 72.2C58.7607 72.5067 59.2807 72.66 59.9341 72.66C60.6674 72.66 61.3007 72.4733 61.8341 72.1C62.3674 71.7133 62.6341 71.2 62.6341 70.56C62.6341 70.36 62.5807 70.1867 62.4741 70.04C62.3807 69.88 62.2674 69.7467 62.1341 69.64C62.0007 69.5333 61.8074 69.4333 61.5541 69.34C61.3007 69.2333 61.0741 69.1533 60.8741 69.1C60.6874 69.0333 60.4274 68.96 60.0941 68.88C59.7607 68.7867 59.4941 68.7133 59.2941 68.66C59.1074 68.6067 58.8607 68.5267 58.5541 68.42C58.2474 68.3 58.0007 68.1867 57.8141 68.08C57.6274 67.9733 57.4207 67.8333 57.1941 67.66C56.9674 67.4867 56.7941 67.3067 56.6741 67.12C56.5541 66.92 56.4474 66.6867 56.3541 66.42C56.2741 66.14 56.2341 65.8467 56.2341 65.54C56.2341 63.98 56.7674 62.7867 57.8341 61.96C58.9007 61.12 60.3074 60.7 62.0541 60.7C62.9341 60.7 63.6941 60.84 64.3341 61.12C64.9741 61.3867 65.4674 61.7867 65.8141 62.32C66.1607 62.8533 66.3341 63.4933 66.3341 64.24C66.3341 64.56 66.3074 64.8867 66.2541 65.22H63.3941C63.4207 65.0867 63.4341 64.96 63.4341 64.84C63.4341 64.3467 63.2607 63.9667 62.9141 63.7C62.5807 63.42 62.1207 63.28 61.5341 63.28C60.8541 63.28 60.2874 63.44 59.8341 63.76C59.3807 64.0667 59.1541 64.4933 59.1541 65.04C59.1541 65.2133 59.2007 65.3733 59.2941 65.52C59.3874 65.6667 59.4941 65.7867 59.6141 65.88C59.7474 65.9733 59.9341 66.0733 60.1741 66.18C60.4141 66.2733 60.6274 66.3467 60.8141 66.4C61.0007 66.4533 61.2541 66.5267 61.5741 66.62C61.9207 66.7 62.1874 66.7733 62.3741 66.84C62.5741 66.8933 62.8341 66.98 63.1541 67.1C63.4741 67.2067 63.7274 67.32 63.9141 67.44C64.1141 67.5467 64.3341 67.6933 64.5741 67.88C64.8141 68.0533 64.9941 68.2467 65.1141 68.46C65.2474 68.66 65.3607 68.9067 65.4541 69.2C65.5474 69.48 65.5941 69.7933 65.5941 70.14C65.5941 71.22 65.3274 72.1533 64.7941 72.94C64.2607 73.7267 63.5341 74.32 62.6141 74.72C61.7074 75.1067 60.6607 75.3 59.4741 75.3ZM75.3825 66.7H72.3025C71.7425 69.4733 71.4625 70.94 71.4625 71.1C71.4625 71.5267 71.5958 71.86 71.8625 72.1C72.1292 72.3267 72.5158 72.44 73.0225 72.44H74.2625L73.7425 75H72.1825C71.0625 75 70.1892 74.7133 69.5625 74.14C68.9358 73.5667 68.6225 72.78 68.6225 71.78C68.6225 71.4333 68.8225 70.2333 69.2225 68.18C69.3558 67.5667 69.4558 67.0733 69.5225 66.7H67.5425L67.6625 66.1L72.8425 61.38H73.3825L72.8225 64.2H75.8625L75.3825 66.7ZM87.04 64.2H89.2L87.04 75H84.98L84.9 74C83.7933 74.8667 82.5467 75.3 81.16 75.3C80.2133 75.3 79.3733 75.0933 78.64 74.68C77.9067 74.2533 77.34 73.6733 76.94 72.94C76.54 72.2067 76.34 71.3867 76.34 70.48C76.34 69.6 76.5067 68.7533 76.84 67.94C77.1867 67.1267 77.6467 66.4267 78.22 65.84C78.8067 65.2533 79.5067 64.7867 80.32 64.44C81.1333 64.08 81.9933 63.9 82.9 63.9C84.38 63.9 85.5533 64.4333 86.42 65.5L87.04 64.2ZM81.68 72.66C82.6533 72.66 83.5067 72.2867 84.24 71.54C84.9733 70.78 85.34 69.9 85.34 68.9C85.34 68.18 85.1067 67.6067 84.64 67.18C84.1733 66.74 83.56 66.52 82.8 66.52C82.32 66.52 81.8533 66.6267 81.4 66.84C80.96 67.04 80.5733 67.3133 80.24 67.66C79.92 67.9933 79.66 68.3933 79.46 68.86C79.2733 69.3267 79.18 69.8 79.18 70.28C79.18 71 79.4067 71.58 79.86 72.02C80.3133 72.4467 80.92 72.66 81.68 72.66ZM101.168 64.2H102.968L101.048 73.78C100.701 75.5 99.961 76.8267 98.8277 77.76C97.6943 78.7067 96.2743 79.18 94.5677 79.18C93.141 79.18 92.001 78.8067 91.1477 78.06C90.2943 77.3133 89.8543 76.34 89.8277 75.14H92.5877C92.641 75.66 92.8877 76.0667 93.3277 76.36C93.781 76.6533 94.3077 76.8 94.9077 76.8C95.7077 76.8 96.421 76.54 97.0477 76.02C97.6877 75.5 98.101 74.8133 98.2877 73.96L98.3277 73.78C97.341 74.4067 96.2877 74.72 95.1677 74.72C93.861 74.72 92.781 74.2933 91.9277 73.44C91.0743 72.5867 90.6477 71.4867 90.6477 70.14C90.6477 69.0333 90.9343 68 91.5077 67.04C92.081 66.08 92.841 65.32 93.7877 64.76C94.7343 64.1867 95.741 63.9 96.8077 63.9C97.541 63.9 98.221 64.0467 98.8477 64.34C99.4877 64.6333 100.014 65.0467 100.428 65.58L101.168 64.2ZM95.7877 72.2C96.7077 72.2 97.5077 71.8467 98.1877 71.14C98.881 70.42 99.2277 69.58 99.2277 68.62C99.2277 68.18 99.1343 67.7933 98.9477 67.46C98.761 67.1267 98.4877 66.8733 98.1277 66.7C97.781 66.5133 97.3677 66.42 96.8877 66.42C95.9543 66.42 95.1477 66.78 94.4677 67.5C93.7877 68.22 93.4477 69.0533 93.4477 70C93.4477 70.6667 93.6543 71.2 94.0677 71.6C94.4943 72 95.0677 72.2 95.7877 72.2ZM115.367 70.4H107.007C106.994 70.4533 106.987 70.5 106.987 70.54C106.987 71.2733 107.194 71.84 107.607 72.24C108.02 72.6267 108.607 72.82 109.367 72.82C109.727 72.82 110.074 72.7667 110.407 72.66C110.74 72.54 111.047 72.3867 111.327 72.2C111.607 72 111.847 71.76 112.047 71.48H115.027C114.4 72.6933 113.567 73.6333 112.527 74.3C111.487 74.9667 110.32 75.3 109.027 75.3C107.654 75.3 106.527 74.8467 105.647 73.94C104.78 73.02 104.347 71.8733 104.347 70.5C104.347 69.3133 104.62 68.22 105.167 67.22C105.727 66.2067 106.507 65.4 107.507 64.8C108.507 64.2 109.62 63.9 110.847 63.9C112.247 63.9 113.394 64.36 114.287 65.28C115.18 66.2 115.627 67.3333 115.627 68.68C115.64 69.1867 115.554 69.76 115.367 70.4ZM110.627 66.3C109.934 66.3 109.307 66.5 108.747 66.9C108.2 67.2867 107.774 67.8 107.467 68.44H113.007C112.94 67.7467 112.7 67.22 112.287 66.86C111.887 66.4867 111.334 66.3 110.627 66.3Z'
				fill='white'
			/>
		</svg>
	);
};

export const LogoMini = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '30'} height={height || '25'} viewBox='0 0 30 25' fill='none'>
			<path d='M3.3103 18.1248L21.4137 29.7915H3.3103V36.6665H44.6896L3.3103 9.94775V18.1248Z' fill='black' />
			<path d='M44.6896 21.8752L26.5862 10.2085H44.6896V3.3335H3.3103L44.6896 30.0522V21.8752Z' fill='black' />
		</svg>
	);
};

export const FeatureLogo = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '30'} height={height || '26'} viewBox='0 0 30 26' fill='none'>
			<path
				d='M2.06885 11.8281L13.3835 19.1198H2.06885V23.4166H27.9309L2.06885 6.71741V11.8281Z'
				fill='#171722'
			/>
			<path
				d='M27.9309 14.1719L16.6163 6.88019H27.9309V2.58331H2.06885L27.9309 19.2825V14.1719Z'
				fill='#171722'
			/>
		</svg>
	);
};

export const Dashboard = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '18'} height={height || '18'} viewBox='0 0 18 18' fill='none'>
			<path
				d='M10 18V8H18V18H10ZM0 10V0H8V10H0ZM6 8V2H2V8H6ZM0 18V12H8V18H0ZM2 16H6V14H2V16ZM12 16H16V10H12V16ZM10 0H18V6H10V0ZM12 2V4H16V2H12Z'
				fill='#BDBDCF'
			/>
		</svg>
	);
};

export const Company = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '19'} height={height || '18'} viewBox='0 0 19 18' fill='none'>
			<path
				d='M20 16H22V18H0V16H2V1C2 0.734784 2.10536 0.48043 2.29289 0.292893C2.48043 0.105357 2.73478 0 3 0H13C13.2652 0 13.5196 0.105357 13.7071 0.292893C13.8946 0.48043 14 0.734784 14 1V16H18V8H16V6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7V16ZM4 2V16H12V2H4ZM6 8H10V10H6V8ZM6 4H10V6H6V4Z'
				fill='#BDBDCF'
			/>
		</svg>
	);
};

export const Products = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '19'} height={height || '21'} viewBox='0 0 21 21' fill='none'>
			<path
				d='M10.0206 0.116138L0.661875 4.3172C0.251087 4.49411 0 4.89205 0 5.33438V15.6823C0 16.1245 0.251095 16.5003 0.661875 16.6995L10.0206 20.9005C10.3174 21.0332 10.6824 21.0332 10.9793 20.9005L20.338 16.6995C20.7488 16.5225 20.9998 16.1246 20.9998 15.6823L21 5.33438C21 4.89221 20.7489 4.51632 20.3381 4.3172L10.9794 0.116138C10.6826 -0.0387128 10.3174 -0.0387128 10.0206 0.116138H10.0206ZM18.101 5.15742L10.4999 8.56241L7.94344 7.41277L11.0935 5.99767C11.5272 5.79871 11.7098 5.31227 11.5043 4.89213C11.2989 4.47198 10.7967 4.29509 10.363 4.49421L5.91188 6.50634L2.9217 5.15758L10.5 1.73019L18.101 5.15742ZM1.71187 6.46192L5.02178 7.94335V12.7635C5.02178 13.2279 5.4098 13.6038 5.88921 13.6038C6.36864 13.6038 6.75664 13.2279 6.75664 12.7635L6.75649 8.71723L9.63253 10.0217V18.8882L1.71188 15.3283L1.71187 6.46192ZM11.3673 18.8882V10.0218L19.288 6.46192V15.3284L11.3673 18.8882Z'
				fill='#BDBDCF'
			/>
		</svg>
	);
};

export const Campaigns = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '18'} height={height || '21'} viewBox='0 0 22 24' fill='none'>
			<path
				d='M9.00003 14V20C9.00003 20.2652 8.89468 20.5196 8.70714 20.7071C8.5196 20.8946 8.26525 21 8.00003 21H6.82003C6.58609 21.0047 6.3579 20.9272 6.17518 20.7811C5.99246 20.6349 5.86679 20.4293 5.82003 20.2L4.41003 13'
				stroke='#BDBDCF'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M21 15.72V4.28001C21.0045 4.12581 20.9733 3.97266 20.9088 3.83253C20.8443 3.6924 20.7483 3.5691 20.6282 3.47226C20.5081 3.37542 20.3672 3.30768 20.2166 3.27432C20.066 3.24097 19.9097 3.24292 19.76 3.28L9 6.00001V14L19.76 16.69C19.9072 16.7264 20.0608 16.7288 20.2092 16.6971C20.3575 16.6654 20.4967 16.6003 20.6161 16.5069C20.7356 16.4134 20.8323 16.294 20.8988 16.1577C20.9653 16.0214 20.9999 15.8717 21 15.72ZM9 6.00001H7C5.93913 6.00001 4.92172 6.42143 4.17157 7.17158C3.42143 7.92172 3 8.93914 3 10V10C3 11.0609 3.42143 12.0783 4.17157 12.8284C4.92172 13.5786 5.93913 14 7 14H9V6.00001Z'
				stroke='#BDBDCF'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export const Insight = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '18'} height={height || '24'} viewBox='0 0 23 24' fill='none'>
			<g clipPath='url(#clip0_666_748)'>
				<path
					d='M11 0.543C11.33 0.514 11.663 0.5 12 0.5C18.351 0.5 23.5 5.649 23.5 12C23.5 12.337 23.486 12.67 23.457 13H21.951C21.449 18.053 17.185 22 12 22C6.477 22 2 17.523 2 12C2 6.815 5.947 2.551 11 2.05V0.542V0.543ZM11 13V4.062C8.98271 4.31868 7.13885 5.33387 5.84319 6.90122C4.54752 8.46857 3.89728 10.4705 4.02462 12.5C4.15196 14.5296 5.04733 16.4345 6.52874 17.8276C8.01016 19.2207 9.96645 19.9975 12 20C13.9486 20 15.8302 19.2888 17.2917 18C18.7533 16.7112 19.6942 14.9333 19.938 13H11ZM21.448 11C21.2187 8.8379 20.255 6.81979 18.7176 5.28239C17.1802 3.74498 15.1621 2.78126 13 2.552V11H21.448Z'
					fill='#BDBDCF'
				/>
			</g>
			<defs>
				<clipPath id='clip0_666_748'>
					<rect width='24' height='24' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};

export const Partnership = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '18'} height={height || '20'} viewBox='0 0 20 20' fill='none'>
			<path
				d='M10 9C11.3261 9 12.5979 9.52678 13.5355 10.4645C14.4732 11.4021 15 12.6739 15 14V20H13V14C13 13.2348 12.7077 12.4985 12.1827 11.9417C11.6578 11.385 10.9399 11.0499 10.176 11.005L10 11C9.23479 11 8.49849 11.2923 7.94174 11.8173C7.38499 12.3422 7.04989 13.0601 7.005 13.824L7 14V20H5V14C5 12.6739 5.52678 11.4021 6.46447 10.4645C7.40215 9.52678 8.67392 9 10 9ZM3.5 12C3.779 12 4.05 12.033 4.31 12.094C4.13902 12.603 4.03777 13.1328 4.009 13.669L4 14V14.086C3.88505 14.0449 3.76549 14.018 3.644 14.006L3.5 14C3.12712 14 2.76761 14.1389 2.49158 14.3896C2.21555 14.6403 2.0428 14.9848 2.007 15.356L2 15.5V20H0V15.5C0 14.5717 0.368749 13.6815 1.02513 13.0251C1.6815 12.3687 2.57174 12 3.5 12ZM16.5 12C17.4283 12 18.3185 12.3687 18.9749 13.0251C19.6313 13.6815 20 14.5717 20 15.5V20H18V15.5C18 15.1271 17.8611 14.7676 17.6104 14.4916C17.3597 14.2156 17.0152 14.0428 16.644 14.007L16.5 14C16.325 14 16.157 14.03 16 14.085V14C16 13.334 15.892 12.694 15.691 12.096C15.95 12.033 16.221 12 16.5 12ZM3.5 6C4.16304 6 4.79893 6.26339 5.26777 6.73223C5.73661 7.20107 6 7.83696 6 8.5C6 9.16304 5.73661 9.79893 5.26777 10.2678C4.79893 10.7366 4.16304 11 3.5 11C2.83696 11 2.20107 10.7366 1.73223 10.2678C1.26339 9.79893 1 9.16304 1 8.5C1 7.83696 1.26339 7.20107 1.73223 6.73223C2.20107 6.26339 2.83696 6 3.5 6ZM16.5 6C17.163 6 17.7989 6.26339 18.2678 6.73223C18.7366 7.20107 19 7.83696 19 8.5C19 9.16304 18.7366 9.79893 18.2678 10.2678C17.7989 10.7366 17.163 11 16.5 11C15.837 11 15.2011 10.7366 14.7322 10.2678C14.2634 9.79893 14 9.16304 14 8.5C14 7.83696 14.2634 7.20107 14.7322 6.73223C15.2011 6.26339 15.837 6 16.5 6ZM3.5 8C3.36739 8 3.24021 8.05268 3.14645 8.14645C3.05268 8.24021 3 8.36739 3 8.5C3 8.63261 3.05268 8.75979 3.14645 8.85355C3.24021 8.94732 3.36739 9 3.5 9C3.63261 9 3.75979 8.94732 3.85355 8.85355C3.94732 8.75979 4 8.63261 4 8.5C4 8.36739 3.94732 8.24021 3.85355 8.14645C3.75979 8.05268 3.63261 8 3.5 8ZM16.5 8C16.3674 8 16.2402 8.05268 16.1464 8.14645C16.0527 8.24021 16 8.36739 16 8.5C16 8.63261 16.0527 8.75979 16.1464 8.85355C16.2402 8.94732 16.3674 9 16.5 9C16.6326 9 16.7598 8.94732 16.8536 8.85355C16.9473 8.75979 17 8.63261 17 8.5C17 8.36739 16.9473 8.24021 16.8536 8.14645C16.7598 8.05268 16.6326 8 16.5 8ZM10 0C11.0609 0 12.0783 0.421427 12.8284 1.17157C13.5786 1.92172 14 2.93913 14 4C14 5.06087 13.5786 6.07828 12.8284 6.82843C12.0783 7.57857 11.0609 8 10 8C8.93913 8 7.92172 7.57857 7.17157 6.82843C6.42143 6.07828 6 5.06087 6 4C6 2.93913 6.42143 1.92172 7.17157 1.17157C7.92172 0.421427 8.93913 0 10 0ZM10 2C9.46957 2 8.96086 2.21071 8.58579 2.58579C8.21071 2.96086 8 3.46957 8 4C8 4.53043 8.21071 5.03914 8.58579 5.41421C8.96086 5.78929 9.46957 6 10 6C10.5304 6 11.0391 5.78929 11.4142 5.41421C11.7893 5.03914 12 4.53043 12 4C12 3.46957 11.7893 2.96086 11.4142 2.58579C11.0391 2.21071 10.5304 2 10 2Z'
				fill='#BDBDCF'
			/>
		</svg>
	);
};

export const UserManagement = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '18'} height={height || '20'} viewBox='0 0 18 20' fill='none'>
			<path
				d='M12 2H2V18H16V6H12V2ZM0 0.992C0 0.444 0.447 0 0.999 0H13L18 5V18.993C18.0009 19.1243 17.976 19.2545 17.9266 19.3762C17.8772 19.4979 17.8043 19.6087 17.7121 19.7022C17.6199 19.7957 17.5101 19.8701 17.3892 19.9212C17.2682 19.9723 17.1383 19.9991 17.007 20H0.993C0.730378 19.9982 0.479017 19.8931 0.293218 19.7075C0.107418 19.5219 0.00209465 19.2706 0 19.008V0.992ZM9 9.5C8.33696 9.5 7.70107 9.23661 7.23223 8.76777C6.76339 8.29893 6.5 7.66304 6.5 7C6.5 6.33696 6.76339 5.70107 7.23223 5.23223C7.70107 4.76339 8.33696 4.5 9 4.5C9.66304 4.5 10.2989 4.76339 10.7678 5.23223C11.2366 5.70107 11.5 6.33696 11.5 7C11.5 7.66304 11.2366 8.29893 10.7678 8.76777C10.2989 9.23661 9.66304 9.5 9 9.5ZM4.527 15C4.64822 13.8984 5.17168 12.8803 5.99708 12.1407C6.82248 11.4012 7.89175 10.9922 9 10.9922C10.1082 10.9922 11.1775 11.4012 12.0029 12.1407C12.8283 12.8803 13.3518 13.8984 13.473 15H4.527Z'
				fill='#BDBDCF'
			/>
		</svg>
	);
};

export const Challenges = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '18'} height={height || '20'} viewBox='0 0 18 20' fill='none'>
			<path d='M2 10.5438L10.75 16.4938H2V20H22L2 6.37344V10.5438Z' fill='#BDBDCF' />
			<path d='M22 12.4562L13.25 6.50625H22V3H2L22 16.6266V12.4562Z' fill='#BDBDCF' />
		</svg>
	);
};

export const Reports = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '18'} height={height || '20'} viewBox='0 0 18 20' fill='none'>
			<path
				d='M12 2H2V18H16V6H12V2ZM0 0.992C0 0.444 0.447 0 0.999 0H13L18 5V18.993C18.0009 19.1243 17.976 19.2545 17.9266 19.3762C17.8772 19.4979 17.8043 19.6087 17.7121 19.7022C17.6199 19.7957 17.5101 19.8701 17.3892 19.9212C17.2682 19.9723 17.1383 19.9991 17.007 20H0.993C0.730378 19.9982 0.479017 19.8931 0.293218 19.7075C0.107418 19.5219 0.00209465 19.2706 0 19.008V0.992ZM8 13H10V15H8V13ZM8 5H10V11H8V5Z'
				fill='#BDBDCF'
			/>
		</svg>
	);
};

export const Music = ({ height, width, className }: IIcon) => {
	return (
		<svg width={width || '18'} height={height || '20'} viewBox='0 0 22 25' fill='none' className={className || ''}>
			<path
				d='M22 3.93303V17.915C22 20.365 20.0079 22.3571 17.5579 22.3571C15.1204 22.3571 13.1159 20.365 13.1159 17.915C13.1159 15.4774 15.1204 13.4853 17.5579 13.4853C18.5973 13.4853 19.5253 13.8442 20.2801 14.4381V7.07588L8.88415 10.3177V20.3031C8.88415 22.753 6.87962 24.7452 4.44205 24.7452C1.99211 24.7452 0 22.753 0 20.3031C0 17.8655 1.99211 15.8734 4.44205 15.8734C5.46906 15.8734 6.39707 16.2322 7.15185 16.8138V5.87566C7.15185 4.05676 8.25308 2.64619 9.99776 2.176L17.1496 0.220995C18.5973 -0.174955 19.8223 -0.038847 20.6884 0.629319C21.5669 1.28511 22 2.39872 22 3.93303Z'
				fill='#BDBDCF'
			/>
		</svg>
	);
};

export const Csv = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '22'} height={height || '25'} viewBox='0 0 512 512' fill='none'>
			<path
				d='M391 426H90.333C60.374 426 36 401.626 36 371.667V216C36 210.477 40.478 206 46 206C51.522 206 56 210.477 56 216V371.667C56 390.598 71.401 406 90.333 406H391C399.272 406 406 399.271 406 391V271C406 262.729 399.272 256 391 256H126.001C120.479 256 116.001 251.523 116.001 246C116.001 240.477 120.479 236 126.001 236H391C410.299 236 426 251.701 426 271V391C426 410.299 410.299 426 391 426Z'
				fill='#BDBDCF'
			/>
			<path
				d='M126 256H76C53.944 256 36 238.056 36 216C36 193.944 53.944 176 76 176H126C131.523 176 136 180.477 136 186C136 191.523 131.523 196 126 196H76C64.972 196 56 204.972 56 216C56 227.028 64.972 236 76 236H126C131.523 236 136 240.477 136 246C136 251.523 131.523 256 126 256Z'
				fill='#BDBDCF'
			/>
			<path
				d='M436 496H156C133.944 496 116 478.056 116 456V416C116 410.477 120.478 406 126 406C131.523 406 136 410.477 136 416V456C136 467.028 144.972 476 156 476H436C447.028 476 456 467.028 456 456V110.142L381.857 36H156C144.972 36 136 44.972 136 56V245.999C136 251.522 131.523 255.999 126 255.999C120.478 255.999 116 251.522 116 245.999V56C116 33.944 133.944 16 156 16H386C388.652 16 391.195 17.054 393.071 18.929L473.071 98.929C474.946 100.804 476 103.348 476 106V456C476 478.056 458.056 496 436 496Z'
				fill='#BDBDCF'
			/>
			<path
				d='M456 116H386C380.478 116 376 111.523 376 106V36C376 30.477 380.478 26 386 26C391.522 26 396 30.477 396 36V96H456C461.522 96 466 100.477 466 106C466 111.523 461.522 116 456 116Z'
				fill='#BDBDCF'
			/>
			<path
				d='M256 106H176C170.477 106 166 101.523 166 96C166 90.477 170.477 86 176 86H256C261.522 86 266 90.477 266 96C266 101.523 261.522 106 256 106Z'
				fill='#BDBDCF'
			/>
			<path
				d='M336 146H176C170.477 146 166 141.523 166 136C166 130.477 170.477 126 176 126H336C341.522 126 346 130.477 346 136C346 141.523 341.522 146 336 146Z'
				fill='#BDBDCF'
			/>
			<path
				d='M336 186H176C170.477 186 166 181.523 166 176C166 170.477 170.477 166 176 166H336C341.522 166 346 170.477 346 176C346 181.523 341.522 186 336 186Z'
				fill='#BDBDCF'
			/>
			<path
				d='M171 386C143.43 386 121 363.57 121 336C121 308.43 143.43 286 171 286C176.523 286 181 290.477 181 296C181 301.523 176.523 306 171 306C154.458 306 141 319.458 141 336C141 352.542 154.458 366 171 366C176.523 366 181 370.477 181 376C181 381.523 176.523 386 171 386Z'
				fill='#BDBDCF'
			/>
			<path
				d='M326 386C321.832 386 318.101 383.414 316.637 379.511L286.637 299.511C284.698 294.34 287.318 288.576 292.489 286.636C297.666 284.697 303.424 287.318 305.364 292.488L326 347.52L346.637 292.489C348.577 287.318 354.336 284.697 359.512 286.637C364.683 288.576 367.303 294.34 365.364 299.512L335.364 379.512C333.899 383.414 330.168 386 326 386Z'
				fill='#BDBDCF'
			/>
			<path
				d='M236 386H206C200.477 386 196 381.523 196 376C196 370.477 200.477 366 206 366H236C241.514 366 246 361.514 246 356C246 350.486 241.514 346 236 346H226C209.458 346 196 332.542 196 316C196 299.458 209.458 286 226 286H256C261.522 286 266 290.477 266 296C266 301.523 261.522 306 256 306H226C220.486 306 216 310.486 216 316C216 321.514 220.486 326 226 326H236C252.542 326 266 339.458 266 356C266 372.542 252.542 386 236 386Z'
				fill='#BDBDCF'
			/>
		</svg>
	);
};

export const AddChallengesIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '22'} height={height || '22'} viewBox='0 0 22 22' fill='none'>
			<path
				d='M9.66682 9.66685L9.66682 0.333038L12.3331 0.333039L12.3331 9.66685H21.6669V12.3331H12.3331L12.3331 21.6669H9.66682L9.66682 12.3331L0.333008 12.3331V9.66685H9.66682Z'
				fill='#BDBDCF'
			/>
		</svg>
	);
};

export const AddCampaignIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '50px'} height={height || '50px'} viewBox='0 0 24 24' fill='none'>
			<path
				d='M9.66682 9.66685L9.66682 0.333038L12.3331 0.333039L12.3331 9.66685H21.6669V12.3331H12.3331L12.3331 21.6669H9.66682L9.66682 12.3331L0.333008 12.3331V9.66685H9.66682Z'
				fill='black'
			/>
		</svg>
	);
};

export const AddHashTagIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '14'} height={height || '14'} viewBox='0 0 14 14' fill='none'>
			<path
				d='M6.16676 6.16679L6.16676 0.33316L7.83318 0.333161L7.83318 6.16679H13.6668V7.83321H7.83318L7.83318 13.6668H6.16676L6.16676 7.83321L0.33313 7.83321V6.16679H6.16676Z'
				fill='#171722'
			/>
		</svg>
	);
};

export const RemoveHashTagIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '10'} height={height || '10'} viewBox='0 0 10 10' fill='none'>
			<path
				d='M4.00012 3.29299L6.47512 0.817993L7.18212 1.52499L4.70712 3.99999L7.18212 6.47499L6.47512 7.18199L4.00012 4.70699L1.52512 7.18199L0.818115 6.47499L3.29312 3.99999L0.818115 1.52499L1.52512 0.817993L4.00012 3.29299Z'
				fill='#171722'
			/>
		</svg>
	);
};

export const BookmarkIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '21'} height={height || '21'} viewBox='0 0 21 21' fill='none'>
			<path
				d='M4.66665 2.16666H16.3333C16.5543 2.16666 16.7663 2.25445 16.9226 2.41073C17.0788 2.56701 17.1666 2.77898 17.1666 2.99999V18.9525C17.1667 19.027 17.1469 19.1002 17.1091 19.1644C17.0713 19.2286 17.017 19.2815 16.9518 19.3176C16.8866 19.3536 16.8129 19.3716 16.7384 19.3695C16.664 19.3675 16.5914 19.3455 16.5283 19.3058L10.5 15.525L4.47165 19.305C4.40862 19.3446 4.33614 19.3666 4.26173 19.3687C4.18733 19.3708 4.11372 19.3529 4.04856 19.3169C3.9834 19.2809 3.92907 19.2282 3.89122 19.1641C3.85336 19.1 3.83337 19.0269 3.83331 18.9525V2.99999C3.83331 2.77898 3.92111 2.56701 4.07739 2.41073C4.23367 2.25445 4.44563 2.16666 4.66665 2.16666ZM15.5 3.83332H5.49998V16.6933L10.5 13.5592L15.5 16.6933V3.83332Z'
				fill='#171722'
			/>
		</svg>
	);
};

export const CalendarSideIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '20'} height={height || '20'} viewBox='0 0 20 20' fill='none'>
			<g clipPath='url(#clip0_520_73901)'>
				<path
					d='M14.1667 2.49998H17.5C17.721 2.49998 17.933 2.58778 18.0893 2.74406C18.2455 2.90034 18.3333 3.1123 18.3333 3.33331V16.6666C18.3333 16.8877 18.2455 17.0996 18.0893 17.2559C17.933 17.4122 17.721 17.5 17.5 17.5H2.5C2.27898 17.5 2.06702 17.4122 1.91074 17.2559C1.75446 17.0996 1.66666 16.8877 1.66666 16.6666V3.33331C1.66666 3.1123 1.75446 2.90034 1.91074 2.74406C2.06702 2.58778 2.27898 2.49998 2.5 2.49998H5.83333V0.833313H7.5V2.49998H12.5V0.833313H14.1667V2.49998ZM16.6667 9.16665H3.33333V15.8333H16.6667V9.16665ZM12.5 4.16665H7.5V5.83331H5.83333V4.16665H3.33333V7.49998H16.6667V4.16665H14.1667V5.83331H12.5V4.16665ZM5 10.8333H6.66666V12.5H5V10.8333ZM9.16666 10.8333H10.8333V12.5H9.16666V10.8333ZM13.3333 10.8333H15V12.5H13.3333V10.8333Z'
					fill='white'
				/>
			</g>
			<defs>
				<clipPath id='clip0_520_73901'>
					<rect width='20' height='20' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};

export const CalendarIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '20'} height={height || '20'} viewBox='0 0 20 20' fill='none'>
			<g clipPath='url(#clip0_520_73901)'>
				<path
					d='M14.1667 2.49998H17.5C17.721 2.49998 17.933 2.58778 18.0893 2.74406C18.2455 2.90034 18.3333 3.1123 18.3333 3.33331V16.6666C18.3333 16.8877 18.2455 17.0996 18.0893 17.2559C17.933 17.4122 17.721 17.5 17.5 17.5H2.5C2.27898 17.5 2.06702 17.4122 1.91074 17.2559C1.75446 17.0996 1.66666 16.8877 1.66666 16.6666V3.33331C1.66666 3.1123 1.75446 2.90034 1.91074 2.74406C2.06702 2.58778 2.27898 2.49998 2.5 2.49998H5.83333V0.833313H7.5V2.49998H12.5V0.833313H14.1667V2.49998ZM16.6667 9.16665H3.33333V15.8333H16.6667V9.16665ZM12.5 4.16665H7.5V5.83331H5.83333V4.16665H3.33333V7.49998H16.6667V4.16665H14.1667V5.83331H12.5V4.16665ZM5 10.8333H6.66666V12.5H5V10.8333ZM9.16666 10.8333H10.8333V12.5H9.16666V10.8333ZM13.3333 10.8333H15V12.5H13.3333V10.8333Z'
					fill='black'
				/>
			</g>
			<defs>
				<clipPath id='clip0_520_73901'>
					<rect width='20' height='20' fill='black' />
				</clipPath>
			</defs>
		</svg>
	);
};

export const ChallengesDropDownArrowDown = ({ height, width, className }: IIcon) => {
	return (
		<svg width={width || '20'} height={height || '20'} className={className || ''} viewBox='0 0 20 20' fill='none'>
			<g clipPath='url(#clip0_908_1152)'>
				<path
					d='M10.0924 10.8843L5.96741 6.75931L4.78908 7.93764L10.0924 13.241L15.3957 7.93764L14.2174 6.75931L10.0924 10.8843Z'
					fill='#171722'
				/>
			</g>
			<defs>
				<clipPath id='clip0_908_1152'>
					<rect width='20' height='20' fill='black' />
				</clipPath>
			</defs>
		</svg>
	);
};

export const ChallengesSliderIconDark = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '20'} height={height || '20'} viewBox='0 0 20 20' fill='none'>
			<path
				d='M10.9767 9.99999L6.85167 5.87499L8.03 4.69666L13.3333 9.99999L8.03 15.3033L6.85167 14.125L10.9767 9.99999Z'
				fill='#171722'
			/>
		</svg>
	);
};

export const ChallengesSliderIconLight = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '20'} height={height || '20'} viewBox='0 0 20 20' fill='none'>
			<path
				d='M9.20836 9.99999L13.3334 5.87499L12.155 4.69666L6.85169 9.99999L12.155 15.3033L13.3334 14.125L9.20836 9.99999Z'
				fill='#BDBDCF'
			/>
		</svg>
	);
};

export const Chat = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '20'} height={height || '20'} viewBox='0 0 20 20' fill='none'>
			<g clipPath='url(#clip0_854_789)'>
				<path
					d='M4.80251 14.1667H16.6667V4.16667H3.33334V15.3208L4.80251 14.1667ZM5.37917 15.8333L1.66667 18.75V3.33333C1.66667 3.11232 1.75447 2.90036 1.91075 2.74408C2.06703 2.5878 2.27899 2.5 2.50001 2.5H17.5C17.721 2.5 17.933 2.5878 18.0893 2.74408C18.2455 2.90036 18.3333 3.11232 18.3333 3.33333V15C18.3333 15.221 18.2455 15.433 18.0893 15.5893C17.933 15.7455 17.721 15.8333 17.5 15.8333H5.37917Z'
					fill='#808095'
				/>
			</g>
			<defs>
				<clipPath id='clip0_854_789'>
					<rect width='20' height='20' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};

export const ChatMini = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '20'} height={height || '20'} viewBox='0 0 20 20' fill='none'>
			<path
				d='M4.80251 14.1667H16.6667V4.16667H3.33334V15.3208L4.80251 14.1667ZM5.37917 15.8333L1.66667 18.75V3.33333C1.66667 3.11232 1.75447 2.90036 1.91075 2.74408C2.06703 2.5878 2.27899 2.5 2.50001 2.5H17.5C17.721 2.5 17.933 2.5878 18.0893 2.74408C18.2455 2.90036 18.3333 3.11232 18.3333 3.33333V15C18.3333 15.221 18.2455 15.433 18.0893 15.5893C17.933 15.7455 17.721 15.8333 17.5 15.8333H5.37917Z'
				fill='#808095'
			/>
		</svg>
	);
};

export const CustomizeEdit = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '12'} height={height || '12'} viewBox='0 0 12 12' fill='none'>
			<path
				d='M8.48533 4.45739L7.54267 3.51472L1.33333 9.72406V10.6667H2.276L8.48533 4.45739ZM9.428 3.51472L10.3707 2.57206L9.428 1.62939L8.48533 2.57206L9.428 3.51472ZM2.828 12.0001H0V9.17139L8.95667 0.214722C9.08169 0.0897416 9.25122 0.0195312 9.428 0.0195312C9.60478 0.0195312 9.77432 0.0897416 9.89933 0.214722L11.7853 2.10072C11.9103 2.22574 11.9805 2.39528 11.9805 2.57206C11.9805 2.74883 11.9103 2.91837 11.7853 3.04339L2.82867 12.0001H2.828Z'
				fill='#171722'
			/>
		</svg>
	);
};

export const Filter = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '12'} height={height || '13'} viewBox='0 0 12 13' fill='none'>
			<path
				d='M4 7.00002L0.666667 2.00002H0V0.666687H12V2.00002H11.3333L8 7.00002V12.6667H4V7.00002ZM2.26933 2.00002L5.33333 6.59602V11.3334H6.66667V6.59602L9.73067 2.00002H2.26933Z'
				fill='black'
			/>
		</svg>
	);
};

export const GraphIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '64'} height={height || '27'} viewBox='0 0 64 27' fill='none'>
			<path
				d='M1 27V19.2142L3.68786 15.5659L5.65896 13.1495L8.93902 16.5202L15.1768 25.1614L19.6795 6.31818L20.4744 7.10606L26.0385 17.5455L29.0192 12.6212L32.7949 6.31818L35.1795 2.73091H39.5513H43.1524L44.185 3.88658L52.4679 8.09091L57.4451 1.19549L59.8205 1H63V27H1Z'
				fill='url(#paint0_linear_520_73929)'
				fill-opacity='0.15'
			/>
			<path
				d='M1 19.2783L5.69765 13.295L15.0929 24.6364L19.8782 5.92424L25.8397 17.7424L30.4103 10.2576L35.1795 2.39965L43.2746 2.39965L52.4679 8.28788L57.2493 1L63 1'
				stroke='#00E469'
				strokeWidth='2'
				strokeLinecap='round'
			/>
			<defs>
				<linearGradient
					id='paint0_linear_520_73929'
					x1='27.5202'
					y1='5.65513'
					x2='29.0298'
					y2='27.208'
					gradientUnits='userSpaceOnUse'
				>
					<stop stop-color='#00CE6B' />
					<stop offset='1' stop-color='white' />
				</linearGradient>
			</defs>
		</svg>
	);
};

export const LikesIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '20'} height={height || '21'} viewBox='0 0 20 21' fill='none'>
			<path
				d='M2.63417 4.22418C3.60089 3.25729 4.8975 2.69175 6.26384 2.64106C7.63017 2.59036 8.96512 3.05825 10.0008 3.95085C11.0356 3.05974 12.3688 2.59237 13.7335 2.64232C15.0982 2.69226 16.3937 3.25582 17.3606 4.22019C18.3275 5.18455 18.8944 6.47854 18.9479 7.84309C19.0014 9.20764 18.5376 10.5421 17.6492 11.5792L11.1783 18.0708C10.881 18.3682 10.4823 18.5423 10.0621 18.558C9.64189 18.5738 9.23125 18.4301 8.9125 18.1558L8.82084 18.0717L2.35084 11.5792C1.46291 10.543 0.998821 9.20977 1.05135 7.84617C1.10388 6.48256 1.66916 5.18903 2.63417 4.22418ZM3.8125 5.40251C3.13104 6.08417 2.73822 7.00205 2.71556 7.96566C2.69291 8.92926 3.04216 9.86459 3.69084 10.5775L3.8125 10.7058L10 16.8933L14.4192 12.4733L11.4733 9.52751L10.59 10.4108C10.3579 10.6431 10.0823 10.8273 9.77901 10.953C9.4757 11.0787 9.15059 11.1435 8.82226 11.1436C8.15916 11.1437 7.52316 10.8805 7.05417 10.4117C6.58518 9.94291 6.32162 9.30703 6.32146 8.64394C6.3213 7.98084 6.58457 7.34484 7.05334 6.87585L8.80501 5.12335C8.1079 4.56699 7.23535 4.27726 6.34391 4.30612C5.45247 4.33498 4.6005 4.68056 3.94084 5.28085L3.8125 5.40251ZM10.8842 7.75918C11.0404 7.60296 11.2524 7.51519 11.4733 7.51519C11.6943 7.51519 11.9062 7.60296 12.0625 7.75918L15.5975 11.2942L16.1875 10.7058C16.8804 10.0135 17.2748 9.07745 17.2865 8.09798C17.2982 7.11852 16.9262 6.17336 16.25 5.46464C15.5739 4.75592 14.6472 4.33991 13.6683 4.30556C12.6894 4.27121 11.7358 4.62126 11.0117 5.28085L10.8842 5.40251L8.2325 8.05418C8.08806 8.19853 8.00165 8.39088 7.98967 8.59474C7.97769 8.79859 8.04097 8.99974 8.1675 9.16002L8.2325 9.23251C8.37685 9.37696 8.56921 9.46337 8.77306 9.47535C8.97691 9.48733 9.17807 9.42405 9.33834 9.29751L9.41084 9.23251L10.8842 7.75918Z'
				fill='#171722'
			/>
		</svg>
	);
};

export const LogoBig = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '48'} height={height || '40'} viewBox='0 0 48 40' fill='none'>
			<path d='M3.3103 18.1248L21.4137 29.7915H3.3103V36.6665H44.6896L3.3103 9.94775V18.1248Z' fill='white' />
			<path d='M44.6896 21.8752L26.5862 10.2085H44.6896V3.3335H3.3103L44.6896 30.0522V21.8752Z' fill='white' />
		</svg>
	);
};

export const MailIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '20'} height={height || '20'} viewBox='0 0 20 20' fill='none'>
			<path
				d='M2.50001 2.5H17.5C17.721 2.5 17.933 2.5878 18.0893 2.74408C18.2455 2.90036 18.3333 3.11232 18.3333 3.33333V16.6667C18.3333 16.8877 18.2455 17.0996 18.0893 17.2559C17.933 17.4122 17.721 17.5 17.5 17.5H2.50001C2.27899 17.5 2.06703 17.4122 1.91075 17.2559C1.75447 17.0996 1.66667 16.8877 1.66667 16.6667V3.33333C1.66667 3.11232 1.75447 2.90036 1.91075 2.74408C2.06703 2.5878 2.27899 2.5 2.50001 2.5ZM16.6667 6.03167L10.06 11.9483L3.33334 6.01333V15.8333H16.6667V6.03167ZM3.75917 4.16667L10.0508 9.71833L16.2517 4.16667H3.75917Z'
				fill='#808095'
			/>
		</svg>
	);
};

export const Notification = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '20'} height={height || '20'} viewBox='0 0 20 20' fill='none'>
			<path
				d='M4.16667 15H15.8333V9.19246C15.8333 5.95663 13.2217 3.33329 10 3.33329C6.77833 3.33329 4.16667 5.95663 4.16667 9.19246V15ZM10 1.66663C14.1417 1.66663 17.5 5.03579 17.5 9.19246V16.6666H2.5V9.19246C2.5 5.03579 5.85833 1.66663 10 1.66663ZM7.91667 17.5H12.0833C12.0833 18.0525 11.8638 18.5824 11.4731 18.9731C11.0824 19.3638 10.5525 19.5833 10 19.5833C9.44747 19.5833 8.91756 19.3638 8.52686 18.9731C8.13616 18.5824 7.91667 18.0525 7.91667 17.5Z'
				fill='#171722'
			/>
		</svg>
	);
};

export const ReportSliderArrowIconLeft = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '8'} height={height || '11'} viewBox='0 0 8 11' fill='none'>
			<path
				d='M3.20836 5.49999L7.33336 1.37499L6.15503 0.196655L0.851692 5.49999L6.15503 10.8033L7.33336 9.62499L3.20836 5.49999Z'
				fill='#BDBDCF'
			/>
		</svg>
	);
};

export const ReportWinIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '14'} height={height || '15'} viewBox='0 0 14 15' fill='none'>
			<g clipPath='url(#clip0_907_644)'>
				<path
					d='M7.58331 10.3805V11.5833H10.5V12.75H3.49998V11.5833H6.41665V10.3805C5.28889 10.2383 4.25179 9.6894 3.49998 8.83685C2.74817 7.9843 2.33333 6.88669 2.33331 5.75V2.25H11.6666V5.75C11.6666 6.88669 11.2518 7.9843 10.5 8.83685C9.74817 9.6894 8.71107 10.2383 7.58331 10.3805ZM3.49998 3.41667V5.75C3.49998 6.67826 3.86873 7.5685 4.52511 8.22487C5.18148 8.88125 6.07172 9.25 6.99998 9.25C7.92824 9.25 8.81848 8.88125 9.47485 8.22487C10.1312 7.5685 10.5 6.67826 10.5 5.75V3.41667H3.49998ZM0.583313 3.41667H1.74998V5.75H0.583313V3.41667ZM12.25 3.41667H13.4166V5.75H12.25V3.41667Z'
					fill='white'
				/>
			</g>
			<defs>
				<clipPath id='clip0_907_644'>
					<rect width='14' height='14' fill='white' transform='translate(0 0.5)' />
				</clipPath>
			</defs>
		</svg>
	);
};

export const SalesGoalArrowIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '6'} height={height || '10'} viewBox='0 0 6 10' fill='none'>
			<path
				d='M3.78132 5.00001L0.481323 1.70001L1.42399 0.757339L5.66666 5.00001L1.42399 9.24267L0.481323 8.30001L3.78132 5.00001Z'
				fill='white'
			/>
		</svg>
	);
};

export const Search = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '40'} height={height || '20'} viewBox='0 0 20 20' fill='none'>
			<path
				d='M15.0258 13.8475L18.595 17.4158L17.4158 18.595L13.8475 15.0258C12.5197 16.0901 10.8683 16.669 9.16663 16.6666C5.02663 16.6666 1.66663 13.3066 1.66663 9.16663C1.66663 5.02663 5.02663 1.66663 9.16663 1.66663C13.3066 1.66663 16.6666 5.02663 16.6666 9.16663C16.669 10.8683 16.0901 12.5197 15.0258 13.8475ZM13.3541 13.2291C14.4117 12.1415 15.0023 10.6837 15 9.16663C15 5.94329 12.3891 3.33329 9.16663 3.33329C5.94329 3.33329 3.33329 5.94329 3.33329 9.16663C3.33329 12.3891 5.94329 15 9.16663 15C10.6837 15.0023 12.1415 14.4117 13.2291 13.3541L13.3541 13.2291Z'
				fill='#808095'
			/>
		</svg>
	);
};

export const SearchFilter = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '16'} height={height || '10'} viewBox='0 0 16 10' fill='none'>
			<path
				d='M6.33333 10H9.66667V8.33333H6.33333V10ZM0.5 0V1.66667H15.5V0H0.5ZM3 5.83333H13V4.16667H3V5.83333Z'
				fill='#171722'
			/>
		</svg>
	);
};

export const ShareIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '20'} height={height || '21'} viewBox='0 0 20 21' fill='none'>
			<path
				d='M10.8333 12.1667H9.16667C7.79967 12.1662 6.45853 12.5393 5.28823 13.2458C4.11793 13.9522 3.163 14.9651 2.52667 16.175C2.50878 15.9505 2.49989 15.7253 2.5 15.5C2.5 10.8975 6.23083 7.16668 10.8333 7.16668V2.58334L19.5833 9.66668L10.8333 16.75V12.1667ZM9.16667 10.5H12.5V13.2567L16.9342 9.66668L12.5 6.07668V8.83334H10.8333C9.87521 8.83227 8.92816 9.03819 8.05699 9.43703C7.18582 9.83586 6.4111 10.4182 5.78583 11.1442C6.86193 10.7177 8.00914 10.4991 9.16667 10.5Z'
				fill='#171722'
			/>
		</svg>
	);
};

export const SliderIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '8'} height={height || '11'} viewBox='0 0 8 11' fill='none'>
			<path
				d='M4.97667 5.49999L0.851669 1.37499L2.03 0.196655L7.33334 5.49999L2.03 10.8033L0.851669 9.62499L4.97667 5.49999Z'
				fill='#171722'
			/>
		</svg>
	);
};

export const SliderIconLight = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '8'} height={height || '11'} viewBox='0 0 8 11' fill='none'>
			<path
				d='M3.20836 5.49999L7.33336 1.37499L6.15503 0.196655L0.851692 5.49999L6.15503 10.8033L7.33336 9.62499L3.20836 5.49999Z'
				fill='#BDBDCF'
			/>
		</svg>
	);
};

export const User = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '14'} height={height || '19'} viewBox='0 0 14 19' fill='none'>
			<path
				d='M0.333336 18.3334C0.333336 16.5653 1.03571 14.8696 2.28596 13.6193C3.5362 12.3691 5.23189 11.6667 7 11.6667C8.76811 11.6667 10.4638 12.3691 11.714 13.6193C12.9643 14.8696 13.6667 16.5653 13.6667 18.3334H12C12 17.0073 11.4732 15.7355 10.5355 14.7978C9.59785 13.8602 8.32608 13.3334 7 13.3334C5.67392 13.3334 4.40215 13.8602 3.46447 14.7978C2.52679 15.7355 2 17.0073 2 18.3334H0.333336ZM7 10.8334C4.2375 10.8334 2 8.59587 2 5.83337C2 3.07087 4.2375 0.833374 7 0.833374C9.7625 0.833374 12 3.07087 12 5.83337C12 8.59587 9.7625 10.8334 7 10.8334ZM7 9.16671C8.84167 9.16671 10.3333 7.67504 10.3333 5.83337C10.3333 3.99171 8.84167 2.50004 7 2.50004C5.15834 2.50004 3.66667 3.99171 3.66667 5.83337C3.66667 7.67504 5.15834 9.16671 7 9.16671Z'
				fill='black'
			/>
		</svg>
	);
};

export const UserList = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '100px'} height={height || '100px'} viewBox='-5 0 24 24' fill='none'>
			<path
				d='M0.333336 18.3334C0.333336 16.5653 1.03571 14.8696 2.28596 13.6193C3.5362 12.3691 5.23189 11.6667 7 11.6667C8.76811 11.6667 10.4638 12.3691 11.714 13.6193C12.9643 14.8696 13.6667 16.5653 13.6667 18.3334H12C12 17.0073 11.4732 15.7355 10.5355 14.7978C9.59785 13.8602 8.32608 13.3334 7 13.3334C5.67392 13.3334 4.40215 13.8602 3.46447 14.7978C2.52679 15.7355 2 17.0073 2 18.3334H0.333336ZM7 10.8334C4.2375 10.8334 2 8.59587 2 5.83337C2 3.07087 4.2375 0.833374 7 0.833374C9.7625 0.833374 12 3.07087 12 5.83337C12 8.59587 9.7625 10.8334 7 10.8334ZM7 9.16671C8.84167 9.16671 10.3333 7.67504 10.3333 5.83337C10.3333 3.99171 8.84167 2.50004 7 2.50004C5.15834 2.50004 3.66667 3.99171 3.66667 5.83337C3.66667 7.67504 5.15834 9.16671 7 9.16671Z'
				fill='black'
			/>
		</svg>
	);
};

export const VideoReportArrowIconRight = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '8'} height={height || '11'} viewBox='0 0 8 11' fill='none'>
			<path
				d='M4.97667 5.49999L0.851669 1.37499L2.03 0.196655L7.33334 5.49999L2.03 10.8033L0.851669 9.62499L4.97667 5.49999Z'
				fill='#171722'
			/>
		</svg>
	);
};

export const Delete = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '18'} height={height || '18'} viewBox='0 0 18 18' fill='none'>
			<path
				d='M15.6667 4.83332V16.5C15.6667 16.721 15.5789 16.933 15.4226 17.0892C15.2663 17.2455 15.0544 17.3333 14.8334 17.3333H3.16669C2.94567 17.3333 2.73371 17.2455 2.57743 17.0892C2.42115 16.933 2.33335 16.721 2.33335 16.5V4.83332H0.666687V3.16666H17.3334V4.83332H15.6667ZM4.00002 4.83332V15.6667H14V4.83332H4.00002ZM4.83335 0.666656H13.1667V2.33332H4.83335V0.666656ZM8.16669 7.33332H9.83335V13.1667H8.16669V7.33332Z'
				fill='white'
			/>
		</svg>
	);
};

export const DeleteCampaigns = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '18'} height={height || '18'} viewBox='0 0 18 18' fill='none'>
			<path
				d='M15.6667 4.83332V16.5C15.6667 16.721 15.5789 16.933 15.4226 17.0892C15.2663 17.2455 15.0544 17.3333 14.8334 17.3333H3.16669C2.94567 17.3333 2.73371 17.2455 2.57743 17.0892C2.42115 16.933 2.33335 16.721 2.33335 16.5V4.83332H0.666687V3.16666H17.3334V4.83332H15.6667ZM4.00002 4.83332V15.6667H14V4.83332H4.00002ZM4.83335 0.666656H13.1667V2.33332H4.83335V0.666656ZM8.16669 7.33332H9.83335V13.1667H8.16669V7.33332Z'
				fill='white'
			/>
		</svg>
	);
};

export const DeleteChallenge = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '14'} height={height || '14'} viewBox='0 0 18 18' fill='none'>
			<path
				d='M15.6667 4.83332V16.5C15.6667 16.721 15.5789 16.933 15.4226 17.0892C15.2663 17.2455 15.0544 17.3333 14.8334 17.3333H3.16669C2.94567 17.3333 2.73371 17.2455 2.57743 17.0892C2.42115 16.933 2.33335 16.721 2.33335 16.5V4.83332H0.666687V3.16666H17.3334V4.83332H15.6667ZM4.00002 4.83332V15.6667H14V4.83332H4.00002ZM4.83335 0.666656H13.1667V2.33332H4.83335V0.666656ZM8.16669 7.33332H9.83335V13.1667H8.16669V7.33332Z'
				fill='black'
			/>
		</svg>
	);
};

export const SliderCloseIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '32'} height={height || '32'} viewBox='0 0 32 32' fill='none'>
			<g clipPath='url(#clip0_520_74347)'>
				<path
					d='M16 14.1147L22.6 7.51466L24.4853 9.4L17.8853 16L24.4853 22.6L22.6 24.4853L16 17.8853L9.4 24.4853L7.51466 22.6L14.1147 16L7.51466 9.4L9.4 7.51466L16 14.1147Z'
					fill='white'
				/>
			</g>
			<defs>
				<clipPath id='clip0_520_74347'>
					<rect width='32' height='32' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};

export const ModalSliderIconRight = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '12'} height={height || '18'} viewBox='0 0 12 18' fill='none'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M0.87368 1.57503L8.29868 9.00002L0.87368 16.425L2.28757 17.8389L11.1265 9.00002L2.28757 0.161133L0.87368 1.57503Z'
				fill='#171722'
			/>
		</svg>
	);
};

export const CalenderUserWinnerIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '12'} height={height || '13'} viewBox='0 0 12 13' fill='none'>
			<path
				d='M6.5 8.969V10H9V11H3V10H5.5V8.969C4.53335 8.84711 3.64441 8.37663 3 7.64587C2.35559 6.91512 2.00002 5.97431 2 5V2H10V5C9.99998 5.97431 9.64441 6.91512 9 7.64587C8.35559 8.37663 7.46665 8.84711 6.5 8.969ZM3 3V5C3 5.79565 3.31607 6.55871 3.87868 7.12132C4.44129 7.68393 5.20435 8 6 8C6.79565 8 7.55871 7.68393 8.12132 7.12132C8.68393 6.55871 9 5.79565 9 5V3H3ZM0.5 3H1.5V5H0.5V3ZM10.5 3H11.5V5H10.5V3Z'
				fill='#808095'
			/>
		</svg>
	);
};

export const ReportsFileWarningIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '20'} height={height || '20'} viewBox='0 0 20 20' fill='none'>
			<path
				d='M12.5 3.33335H4.16667V16.6667H15.8333V6.66669H12.5V3.33335ZM2.5 2.49335C2.5 2.03669 2.8725 1.66669 3.3325 1.66669H13.3333L17.5 5.83335V17.4942C17.5008 17.6036 17.48 17.7121 17.4388 17.8135C17.3976 17.9149 17.3369 18.0072 17.2601 18.0852C17.1832 18.1631 17.0918 18.2251 16.991 18.2677C16.8902 18.3103 16.7819 18.3326 16.6725 18.3334H3.3275C3.10865 18.3318 2.89918 18.2443 2.74435 18.0896C2.58951 17.9349 2.50175 17.7255 2.5 17.5067V2.49335ZM9.16667 12.5H10.8333V14.1667H9.16667V12.5ZM9.16667 5.83335H10.8333V10.8334H9.16667V5.83335Z'
				fill='#171722'
			/>
		</svg>
	);
};

export const CloseIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '27'} height={height || '27'} viewBox='0 0 32 32' fill='none'>
			<g clipPath='url(#clip0_520_74347)'>
				<path
					d='M16 14.1147L22.6 7.51466L24.4853 9.4L17.8853 16L24.4853 22.6L22.6 24.4853L16 17.8853L9.4 24.4853L7.51466 22.6L14.1147 16L7.51466 9.4L9.4 7.51466L16 14.1147Z'
					fill='black'
				/>
			</g>
			<defs>
				<clipPath id='clip0_520_74347'>
					<rect width='32' height='32' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};
export const VideoIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '100px'} height={height || '100px'} viewBox='0 0 24 24' fill='none'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M2 9C2 6.79086 3.79086 5 6 5H13C15.2091 5 17 6.79086 17 9V9.07171L20.202 7.23108C21.0019 6.77121 22 7.34868 22 8.27144V15.7488C22 16.6203 21.1003 17.2012 20.306 16.8424L16.9855 15.3425C16.8118 17.3913 15.0938 19 13 19H6C3.79086 19 2 17.2091 2 15V9ZM17 13.1544L20 14.5096V9.65407L17 11.3786V13.1544ZM15 9C15 7.89543 14.1046 7 13 7H6C4.89543 7 4 7.89543 4 9V15C4 16.1046 4.89543 17 6 17H13C14.1046 17 15 16.1046 15 15V9Z'
				fill='#000000'
			/>
		</svg>
	);
};

export const View = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '24'} height={height || '24'} viewBox='0 0 512 512' fill={'#fff'}>
			<g transform='translate(0 -1)'>
				<g>
					<g>
						<path
							d='M505.752,241.915l-89.088-89.088c-88.737-88.737-232.591-88.737-321.327,0L6.248,241.915
				c-8.331,8.331-8.331,21.839,0,30.17l89.088,89.088c88.737,88.737,232.591,88.737,321.327,0l89.088-89.088
				C514.083,263.754,514.083,250.246,505.752,241.915z M386.494,331.003c-72.074,72.074-188.913,72.074-260.987,0L51.503,257
				l74.003-74.003c72.074-72.074,188.913-72.074,260.987,0L460.497,257L386.494,331.003z'
						/>
						<path
							d='M256,150.333c-58.907,0-106.667,47.759-106.667,106.667S197.093,363.667,256,363.667S362.667,315.907,362.667,257
				S314.907,150.333,256,150.333z M256,321c-35.343,0-64-28.657-64-64s28.657-64,64-64s64,28.657,64,64S291.343,321,256,321z'
						/>
					</g>
				</g>
			</g>
		</svg>
	);
};

export const ZoomOutIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '15'} height={height || '3'} viewBox='0 0 15 3' fill='none'>
			<path
				d='M6.88604 0.884699L7.5 0.891124L8.5 0.879702L8.60707 0.886127L14.6319 0.891124L14.6305 2.61215L8.60564 2.60715L8.22477 2.61215L7.5 2.61215L6.88461 2.60573L0.8598 2.60073L0.861228 0.879702L6.88604 0.884699Z'
				fill='#171722'
			/>
		</svg>
	);
};

export const ZoomInIcon = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '15'} height={height || '14'} viewBox='0 0 15 14' fill='none'>
			<path
				d='M6.88604 6.56847L6.89104 0.820231L8.61207 0.821593L8.60707 6.56983L14.6319 6.5746L14.6305 8.21662L8.60564 8.21186L8.60064 13.9601L6.87962 13.9587L6.88461 8.21049L0.8598 8.20573L0.861228 6.5637L6.88604 6.56847Z'
				fill='#171722'
			/>
		</svg>
	);
};

export const PauseIcon = ({ height, width }: IIcon) => {
	return (
		<svg
			width={width || '60'}
			height={height || '60'}
			fill='currentColor'
			className='bi bi-pause-circle'
			viewBox='0 0 16 16'
		>
			<path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />{' '}
			<path d='M5 6.25a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5zm3.5 0a1.25 1.25 0 1 1 2.5 0v3.5a1.25 1.25 0 1 1-2.5 0v-3.5z' />{' '}
		</svg>
	);
};

export const PlayIcon = ({ height, width }: IIcon) => {
	return (
		<svg
			width={width || '60'}
			height={height || '60'}
			fill='currentColor'
			className='bi bi-play-circle'
			viewBox='0 0 16 16'
		>
			<path d='M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z' />{' '}
			<path d='M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z' />{' '}
		</svg>
	);
};

export const IconEye = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '14'} height={height || '15'} viewBox='0 0 11 11' fill='#000000'>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M3.29477 5.49983C3.29477 4.28429 4.28348 3.29517 5.50033 3.29517C6.7159 3.29517 7.70458 4.28427 7.70458 5.49983C7.70458 6.71565 6.7159 7.70434 5.50033 7.70434C4.28346 7.70434 3.29477 6.71565 3.29477 5.49983ZM0.613193 5.2895C0.537139 5.42706 0.537139 5.5726 0.613193 5.71029C1.60059 7.4834 3.47309 8.58488 5.50033 8.58488C7.52624 8.58488 9.39876 7.48342 10.3862 5.71029C10.4635 5.5726 10.4635 5.42706 10.3862 5.2895C9.39876 3.51639 7.52626 2.41504 5.50033 2.41504C3.47309 2.41504 1.60059 3.51639 0.613193 5.2895ZM5.50033 4.01769C4.6821 4.01769 4.01726 4.6825 4.01726 5.49983C4.01726 6.31714 4.68208 6.98197 5.50033 6.98197C6.31725 6.98197 6.98207 6.31716 6.98207 5.49983C6.98207 4.6825 6.31725 4.01769 5.50033 4.01769Z'
				fill='white'
			/>
		</svg>
	);
};

export const IconGoogle = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '30'} height={height || '30'} viewBox='-3 0 262 262'>
			<g>
				<path
					d='M255.878,133.451 C255.878,122.717 255.007,114.884 253.122,106.761 L130.55,106.761 L130.55,155.209 L202.497,155.209 C201.047,167.249 193.214,185.381 175.807,197.565 L175.563,199.187 L214.318,229.21 L217.003,229.478 C241.662,206.704 255.878,173.196 255.878,133.451'
					fill='#4285F4'
				/>
				<path
					d='M130.55,261.1 C165.798,261.1 195.389,249.495 217.003,229.478 L175.807,197.565 C164.783,205.253 149.987,210.62 130.55,210.62 C96.027,210.62 66.726,187.847 56.281,156.37 L54.75,156.5 L14.452,187.687 L13.925,189.152 C35.393,231.798 79.49,261.1 130.55,261.1'
					fill='#34A853'
				/>
				<path
					d='M56.281,156.37 C53.525,148.247 51.93,139.543 51.93,130.55 C51.93,121.556 53.525,112.853 56.136,104.73 L56.063,103 L15.26,71.312 L13.925,71.947 C5.077,89.644 0,109.517 0,130.55 C0,151.583 5.077,171.455 13.925,189.152 L56.281,156.37'
					fill='#FBBC05'
				/>
				<path
					d='M130.55,50.479 C155.064,50.479 171.6,61.068 181.029,69.917 L217.873,33.943 C195.245,12.91 165.798,0 130.55,0 C79.49,0 35.393,29.301 13.925,71.947 L56.136,104.73 C66.726,73.253 96.027,50.479 130.55,50.479'
					fill='#EB4335'
				/>
			</g>
		</svg>
	);
};

export const IconApple = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '30'} height={height || '30'} viewBox='-1.5 0 20 20'>
			<g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
				<g id='Dribbble-Light-Preview' transform='translate(-102.000000, -7439.000000)' fill='#000000'>
					<g id='icons' transform='translate(56.000000, 160.000000)'>
						<path
							d='M57.5708873,7282.19296 C58.2999598,7281.34797 58.7914012,7280.17098 58.6569121,7279 C57.6062792,7279.04 56.3352055,7279.67099 55.5818643,7280.51498 C54.905374,7281.26397 54.3148354,7282.46095 54.4735932,7283.60894 C55.6455696,7283.69593 56.8418148,7283.03894 57.5708873,7282.19296 M60.1989864,7289.62485 C60.2283111,7292.65181 62.9696641,7293.65879 63,7293.67179 C62.9777537,7293.74279 62.562152,7295.10677 61.5560117,7296.51675 C60.6853718,7297.73474 59.7823735,7298.94772 58.3596204,7298.97372 C56.9621472,7298.99872 56.5121648,7298.17973 54.9134635,7298.17973 C53.3157735,7298.17973 52.8162425,7298.94772 51.4935978,7298.99872 C50.1203933,7299.04772 49.0738052,7297.68074 48.197098,7296.46676 C46.4032359,7293.98379 45.0330649,7289.44985 46.8734421,7286.3899 C47.7875635,7284.87092 49.4206455,7283.90793 51.1942837,7283.88393 C52.5422083,7283.85893 53.8153044,7284.75292 54.6394294,7284.75292 C55.4635543,7284.75292 57.0106846,7283.67793 58.6366882,7283.83593 C59.3172232,7283.86293 61.2283842,7284.09893 62.4549652,7285.8199 C62.355868,7285.8789 60.1747177,7287.09489 60.1989864,7289.62485'
							id='apple-[#173]'
						/>
					</g>
				</g>
			</g>
		</svg>
	);
};

export const IconPhoneNumber = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '40'} height={height || '40'} viewBox='0 0 1024 1024'>
			<path
				d='M729.6 870.4c0 28.16-23.04 51.2-51.2 51.2H345.6c-28.16 0-51.2-23.04-51.2-51.2V179.2c0-28.16 23.04-51.2 51.2-51.2h332.8c28.16 0 51.2 23.04 51.2 51.2v691.2z'
				fill='#E1E0A6'
			/>
			<path
				d='M678.4 934.4H345.6c-35.84 0-64-28.16-64-64V179.2c0-35.84 28.16-64 64-64h332.8c35.84 0 64 28.16 64 64v691.2c0 35.84-28.16 64-64 64zM345.6 140.8c-21.76 0-38.4 16.64-38.4 38.4v691.2c0 21.76 16.64 38.4 38.4 38.4h332.8c21.76 0 38.4-16.64 38.4-38.4V179.2c0-21.76-16.64-38.4-38.4-38.4H345.6z'
				fill='#231C1C'
			/>
			<path
				d='M691.2 744.96c0 12.8-11.52 23.04-25.6 23.04H358.4c-14.08 0-25.6-10.24-25.6-23.04V253.44c0-12.8 11.52-23.04 25.6-23.04h307.2c14.08 0 25.6 10.24 25.6 23.04v491.52z'
				fill='#F2E5CA'
			/>
			<path
				d='M665.6 780.8H358.4c-21.76 0-38.4-16.64-38.4-35.84V253.44c0-20.48 16.64-35.84 38.4-35.84h307.2c21.76 0 38.4 16.64 38.4 35.84v491.52c0 19.2-16.64 35.84-38.4 35.84zM358.4 243.2c-7.68 0-12.8 5.12-12.8 10.24v491.52c0 5.12 5.12 10.24 12.8 10.24h307.2c7.68 0 12.8-5.12 12.8-10.24V253.44c0-5.12-5.12-10.24-12.8-10.24H358.4z'
				fill='#231C1C'
			/>
			<path d='M512 844.8m-38.4 0a38.4 38.4 0 1 0 76.8 0 38.4 38.4 0 1 0-76.8 0Z' fill='#D4594C' />
			<path
				d='M512 896c-28.16 0-51.2-23.04-51.2-51.2s23.04-51.2 51.2-51.2 51.2 23.04 51.2 51.2-23.04 51.2-51.2 51.2z m0-76.8c-14.08 0-25.6 11.52-25.6 25.6s11.52 25.6 25.6 25.6 25.6-11.52 25.6-25.6-11.52-25.6-25.6-25.6z'
				fill='#231C1C'
			/>
			<path d='M460.8 166.4h102.4v25.6h-102.4z' fill='#231C1C' />
		</svg>
	);
};

export const IconFilter = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '40'} height={height || '40'} viewBox='0 0 40 40' fill='none'>
			<g filter='url(#filter0_b_2559_70913)'>
				<rect width='40' height='40' rx='10' fill='white' />
				<g clipPath='url(#clip0_2559_70913)'>
					<path
						d='M18.3333 25H21.6667V23.3333H18.3333V25ZM12.5 15V16.6667H27.5V15H12.5ZM15 20.8333H25V19.1667H15V20.8333Z'
						fill='#171722'
					/>
				</g>
			</g>
			<defs>
				<filter
					id='filter0_b_2559_70913'
					x='-12'
					y='-12'
					width='64'
					height='64'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feGaussianBlur in='BackgroundImageFix' stdDeviation='6' />
					<feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_2559_70913' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_backgroundBlur_2559_70913' result='shape' />
				</filter>
				<clipPath id='clip0_2559_70913'>
					<rect width='20' height='20' fill='white' transform='translate(10 10)' />
				</clipPath>
			</defs>
		</svg>
	);
};

export const IconTripleDots = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '20'} height={height || '20'} viewBox='0 0 20 20' fill='none'>
			<g clipPath='url(#clip0_2741_22092)'>
				<path
					d='M10 2.5C9.3125 2.5 8.75 3.0625 8.75 3.75C8.75 4.4375 9.3125 5 10 5C10.6875 5 11.25 4.4375 11.25 3.75C11.25 3.0625 10.6875 2.5 10 2.5ZM10 15C9.3125 15 8.75 15.5625 8.75 16.25C8.75 16.9375 9.3125 17.5 10 17.5C10.6875 17.5 11.25 16.9375 11.25 16.25C11.25 15.5625 10.6875 15 10 15ZM10 8.75C9.3125 8.75 8.75 9.3125 8.75 10C8.75 10.6875 9.3125 11.25 10 11.25C10.6875 11.25 11.25 10.6875 11.25 10C11.25 9.3125 10.6875 8.75 10 8.75Z'
					fill='#171722'
				/>
			</g>
			<defs>
				<clipPath id='clip0_2741_22092'>
					<rect width='20' height='20' fill='white' />
				</clipPath>
			</defs>
		</svg>
	);
};
export const IconTikMark = ({ height, width }: IIcon) => {
	return (
		<svg width={width || '32'} height={height || '32'} viewBox='0 0 48 48'>
			<circle cx='24' cy='24' r='20' fill='#4dd0e1' />
			<path
				fill='#fff'
				d='M22.491,30.69c-0.576,0-1.152-0.22-1.591-0.659l-6.083-6.084c-0.879-0.878-0.879-2.303,0-3.182 c0.878-0.879,2.304-0.879,3.182,0l6.083,6.084c0.879,0.878,0.879,2.303,0,3.182C23.643,30.47,23.067,30.69,22.491,30.69z'
			/>
			<path
				fill='#fff'
				d='M22.491,30.69c-0.576,0-1.152-0.22-1.591-0.659c-0.879-0.878-0.879-2.303,0-3.182l9.539-9.539 c0.878-0.879,2.304-0.879,3.182,0c0.879,0.878,0.879,2.303,0,3.182l-9.539,9.539C23.643,30.47,23.067,30.69,22.491,30.69z'
			/>
		</svg>
	);
};

export const IconCircle = ({ height, width }: IIcon) => {
	return (
		<svg
			width={width || '16'}
			height={height || '16'}
			shapeRendering='geometricPrecision'
			textRendering='geometricPrecision'
			imageRendering='optimizeQuality'
			fillRule='evenodd'
			clipRule='evenodd'
			viewBox='0 0 512 512'
		>
			<path
				fillRule='nonzero'
				d='M256 0c70.69 0 134.69 28.66 181.02 74.98C483.34 121.31 512 185.31 512 256c0 70.69-28.66 134.69-74.98 181.02C390.69 483.34 326.69 512 256 512c-70.69 0-134.69-28.66-181.02-74.98C28.66 390.69 0 326.69 0 256c0-70.69 28.66-134.69 74.98-181.02C121.31 28.66 185.31 0 256 0zm147.19 108.81C365.52 71.15 313.48 47.85 256 47.85c-57.48 0-109.52 23.3-147.19 60.96C71.15 146.48 47.85 198.52 47.85 256c0 57.48 23.3 109.52 60.96 147.19 37.67 37.66 89.71 60.96 147.19 60.96 57.48 0 109.52-23.3 147.19-60.96 37.66-37.67 60.96-89.71 60.96-147.19 0-57.48-23.3-109.52-60.96-147.19z'
			/>
		</svg>
	);
};

export const Artist = ({ height, width, className }: IIcon) => {
	return (
		<svg width={width || '24'} height={height || '24'} className={className || ''} fill='none'>
			<g id='profile'>
				<g id='Group'>
					<path
						id='Vector'
						d='M11.5788 12.056C14.2176 12.056 16.3568 9.91682 16.3568 7.278C16.3568 4.63918 14.2176 2.5 11.5788 2.5C8.93996 2.5 6.80078 4.63918 6.80078 7.278C6.80078 9.91682 8.93996 12.056 11.5788 12.056Z'
						stroke='#171722'
						strokeWidth='2'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<path
						id='Vector_2'
						fillRule='evenodd'
						clipRule='evenodd'
						d='M4.00002 18.6996C3.99875 18.3637 4.07387 18.0319 4.21971 17.7293C4.67738 16.814 5.968 16.3289 7.03893 16.1092C7.81129 15.9444 8.59432 15.8343 9.38218 15.7797C10.8409 15.6516 12.308 15.6516 13.7666 15.7797C14.5544 15.8349 15.3374 15.945 16.1099 16.1092C17.1808 16.3289 18.4714 16.7683 18.9291 17.7293C19.2224 18.3461 19.2224 19.0622 18.9291 19.679C18.4714 20.6401 17.1808 21.0795 16.1099 21.29C15.3384 21.4616 14.5551 21.5748 13.7666 21.6287C12.5794 21.7293 11.3866 21.7477 10.1968 21.6836C9.92223 21.6836 9.65678 21.6836 9.38218 21.6287C8.59665 21.5755 7.81633 21.4623 7.04809 21.29C5.968 21.0795 4.68653 20.6401 4.21971 19.679C4.07461 19.3729 3.99957 19.0383 4.00002 18.6996Z'
						stroke='#171722'
						strokeWidth='2'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</g>
			</g>
		</svg>
	);
};

export const TableFilter = ({ height, width, className }: IIcon) => {
	return (
		<svg width={width || '11'} height={height || '18'} className={className || ''}>
			<g id='Frame 1321315113'>
				<path
					id='Vector 196'
					d='M9.97127 7.5H1.02873C0.611516 7.5 0.377808 7.01915 0.635572 6.69109L5.10684 1.00038C5.30703 0.745599 5.69297 0.745599 5.89316 1.00038L10.3644 6.69109C10.6222 7.01915 10.3885 7.5 9.97127 7.5Z'
					fill='black'
				/>
				<path
					id='Vector 197'
					d='M9.97127 10.5H1.02873C0.611516 10.5 0.377808 10.9808 0.635572 11.3089L5.10684 16.9996C5.30703 17.2544 5.69297 17.2544 5.89316 16.9996L10.3644 11.3089C10.6222 10.9808 10.3885 10.5 9.97127 10.5Z'
					fill='#848484'
				/>
			</g>
		</svg>
	);
};

export const Clock = ({ height, width, className }: IIcon) => {
	return (
		<svg width={width || '20'} height={height || '20'} className={className || ''} fill='none'>
			<path
				d='M10 4C9.86867 3.99997 9.73862 4.02581 9.61728 4.07605C9.49594 4.12629 9.38569 4.19995 9.29282 4.29282C9.19996 4.38568 9.1263 4.49593 9.07606 4.61728C9.02581 4.73862 8.99997 4.86867 9 5V9H7C6.73479 9 6.48043 9.10536 6.2929 9.29289C6.10536 9.48043 6 9.73478 6 10C6 10.2652 6.10536 10.5196 6.2929 10.7071C6.48043 10.8946 6.73479 11 7 11H10C10.1313 11 10.2614 10.9742 10.3827 10.9239C10.5041 10.8737 10.6143 10.8 10.7072 10.7072C10.8001 10.6143 10.8737 10.5041 10.924 10.3827C10.9742 10.2614 11 10.1313 11 10V5C11 4.86867 10.9742 4.73862 10.924 4.61728C10.8737 4.49593 10.8001 4.38568 10.7072 4.29282C10.6143 4.19995 10.5041 4.12629 10.3827 4.07605C10.2614 4.02581 10.1313 3.99997 10 4ZM10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.997 7.34877 18.9424 4.80699 17.0677 2.93228C15.193 1.05758 12.6512 0.0030331 10 0ZM10 18C8.41775 18 6.87104 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00346 13.0615 2.60896C14.5233 3.21447 15.7727 4.23984 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C17.9976 12.121 17.1539 14.1544 15.6542 15.6542C14.1544 17.1539 12.121 17.9976 10 18Z'
				fill='black'
			/>
		</svg>
	);
};

export const IconCsvFileUpload = ({ height, width, className }: IIcon) => {
	return (
		<svg
			width={width || '60'}
			height={height || '60'}
			className={className || ''}
			version='1.1'
			id='Layer_1'
			viewBox='0 0 303.188 303.188'
		>
			<g>
				<polygon
					style={{ fill: '#E4E4E4' }}
					points='219.821,0 32.842,0 32.842,303.188 270.346,303.188 270.346,50.525 	'
				/>
				<polygon style={{ fill: '#007934' }} points='227.64,25.263 32.842,25.263 32.842,0 219.821,0 	' />
				<g>
					<g>
						<path
							style={{ fill: '#A4A9AD' }}
							d='M114.872,227.984c-2.982,0-5.311,1.223-6.982,3.666c-1.671,2.444-2.507,5.814-2.507,10.109
				c0,8.929,3.396,13.393,10.188,13.393c2.052,0,4.041-0.285,5.967-0.856c1.925-0.571,3.86-1.259,5.808-2.063v10.601
				c-3.872,1.713-8.252,2.57-13.14,2.57c-7.004,0-12.373-2.031-16.107-6.094c-3.734-4.062-5.602-9.934-5.602-17.615
				c0-4.803,0.904-9.023,2.714-12.663c1.809-3.64,4.411-6.438,7.808-8.395c3.396-1.957,7.39-2.937,11.98-2.937
				c5.016,0,9.808,1.09,14.378,3.27l-3.841,9.871c-1.713-0.805-3.428-1.481-5.141-2.031
				C118.681,228.26,116.841,227.984,114.872,227.984z'
						/>
						<path
							style={{ fill: '#A4A9AD' }}
							d='M166.732,250.678c0,2.878-0.729,5.433-2.191,7.665c-1.459,2.232-3.565,3.967-6.315,5.205
				c-2.751,1.237-5.977,1.856-9.681,1.856c-3.089,0-5.681-0.217-7.775-0.65c-2.095-0.434-4.274-1.191-6.538-2.27v-11.172
				c2.391,1.227,4.877,2.186,7.458,2.872c2.582,0.689,4.951,1.032,7.109,1.032c1.862,0,3.227-0.322,4.095-0.969
				c0.867-0.645,1.302-1.476,1.302-2.491c0-0.635-0.175-1.19-0.524-1.666c-0.349-0.477-0.91-0.958-1.682-1.444
				c-0.772-0.486-2.83-1.48-6.173-2.983c-3.026-1.375-5.296-2.708-6.809-3.999s-2.634-2.771-3.364-4.443s-1.095-3.65-1.095-5.936
				c0-4.273,1.555-7.605,4.666-9.997c3.109-2.391,7.384-3.587,12.822-3.587c4.803,0,9.7,1.111,14.694,3.333l-3.841,9.681
				c-4.337-1.989-8.082-2.984-11.234-2.984c-1.63,0-2.814,0.286-3.555,0.857s-1.111,1.28-1.111,2.127
				c0,0.91,0.471,1.725,1.412,2.443c0.941,0.72,3.496,2.031,7.665,3.936c3.999,1.799,6.776,3.729,8.331,5.792
				C165.955,244.949,166.732,247.547,166.732,250.678z'
						/>
						<path
							style={{ fill: '#A4A9AD' }}
							d='M199.964,218.368h14.027l-15.202,46.401H184.03l-15.139-46.401h14.092l6.316,23.519
				c1.312,5.227,2.031,8.865,2.158,10.918c0.148-1.481,0.443-3.333,0.889-5.555c0.443-2.222,0.835-3.967,1.174-5.236
				L199.964,218.368z'
						/>
					</g>
				</g>
				<polygon style={{ fill: '#D1D3D3' }} points='219.821,50.525 270.346,50.525 219.821,0 	' />
				<g>
					<rect x='134.957' y='80.344' style={{ fill: '#007934' }} width='33.274' height='15.418' />
					<rect x='175.602' y='80.344' style={{ fill: '#007934' }} width='33.273' height='15.418' />
					<rect x='134.957' y='102.661' style={{ fill: '#007934' }} width='33.274' height='15.419' />
					<rect x='175.602' y='102.661' style={{ fill: '#007934' }} width='33.273' height='15.419' />
					<rect x='134.957' y='124.979' style={{ fill: '#007934' }} width='33.274' height='15.418' />
					<rect x='175.602' y='124.979' style={{ fill: '#007934' }} width='33.273' height='15.418' />
					<rect x='94.312' y='124.979' style={{ fill: '#007934' }} width='33.273' height='15.418' />
					<rect x='134.957' y='147.298' style={{ fill: '#007934' }} width='33.274' height='15.418' />
					<rect x='175.602' y='147.298' style={{ fill: '#007934' }} width='33.273' height='15.418' />
					<rect x='94.312' y='147.298' style={{ fill: '#007934' }} width='33.273' height='15.418' />
					<g>
						<path
							style={{ fill: '#007934' }}
							d='M127.088,116.162h-10.04l-6.262-10.041l-6.196,10.041h-9.821l10.656-16.435L95.406,84.04h9.624
				l5.8,9.932l5.581-9.932h9.909l-10.173,16.369L127.088,116.162z'
						/>
					</g>
				</g>
			</g>
		</svg>
	);
};

export const IconFileDownload = ({ height, width, className }: IIcon) => {
	return (
		<svg width={width || '36'} height={height || '36'} className={className || ''} viewBox='0 0 36 36' fill='none'>
			<path
				d='M10 25H26V18H28V26C28 26.2652 27.8946 26.5196 27.7071 26.7071C27.5196 26.8946 27.2652 27 27 27H9C8.73478 27 8.48043 26.8946 8.29289 26.7071C8.10536 26.5196 8 26.2652 8 26V18H10V25ZM20 15H25L18 22L11 15H16V9H20V15Z'
				fill='#ffffff'
			/>
		</svg>
	);
};

export const IconOnBoarding = ({ height, width, className }: IIcon) => {
	return (
		<svg width={width || '27'} height={height || '22'} className={className || ''} viewBox='0 0 27 22' fill='none'>
			<path
				d='M20.5436 6.36244L13.7936 2.59102C13.6115 2.48912 13.3885 2.48912 13.2064 2.59102L6.45637 6.36244C6.25921 6.47232 6.13636 6.6841 6.13636 6.91429V11.2518C6.1252 11.262 6.10985 11.2653 6.09921 11.2762C5.92782 11.4524 5.82955 11.6912 5.82955 11.9429C5.82955 12.1878 5.92782 12.4333 6.09921 12.6089C6.2712 12.785 6.5103 12.8857 6.75 12.8857C6.9951 12.8857 7.2288 12.785 7.40019 12.6089C7.57218 12.4333 7.67045 12.1878 7.67045 11.9429C7.67045 11.6912 7.57218 11.4524 7.40019 11.2762C7.38974 11.2655 7.37461 11.2621 7.36364 11.2521V7.97304L8.59091 8.65878V13.8286C8.59091 14.176 8.86537 14.4571 9.20455 14.4571H17.7955C18.1346 14.4571 18.4091 14.176 18.4091 13.8286V8.65878L20.5436 7.46613C20.7408 7.35625 20.8636 7.14448 20.8636 6.91429C20.8636 6.6841 20.7408 6.47232 20.5436 6.36244ZM17.1818 13.2H9.81818V9.34448L13.2064 11.2376C13.2975 11.2885 13.3987 11.3143 13.5 11.3143C13.6013 11.3143 13.7025 11.2885 13.7936 11.2376L17.1818 9.34448V13.2ZM13.5 9.96998L8.03121 6.91429L13.5 3.85859L18.9688 6.91429L13.5 9.96998ZM23.9318 0H3.06818C1.37649 0 0 1.40999 0 3.14286V13.8286C0 15.5614 1.37649 16.9714 3.06818 16.9714H23.9318C25.6235 16.9714 27 15.5614 27 13.8286V3.14286C27 1.40999 25.6235 0 23.9318 0ZM25.7727 13.8286C25.7727 14.8684 24.947 15.7143 23.9318 15.7143H3.06818C2.05305 15.7143 1.22727 14.8684 1.22727 13.8286V3.14286C1.22727 2.10301 2.05305 1.25714 3.06818 1.25714H23.9318C24.947 1.25714 25.7727 2.10301 25.7727 3.14286V13.8286ZM27 20.1143C27 20.4617 26.7255 20.7429 26.3864 20.7429H22.5908C22.4995 21.0045 22.3587 21.2478 22.1646 21.4469C21.8206 21.7987 21.3484 22 20.8636 22C20.3788 22 19.906 21.7987 19.5627 21.4469C19.3682 21.2478 19.2275 21.0045 19.1363 20.7429H0.613636C0.274458 20.7429 0 20.4617 0 20.1143C0 19.7669 0.274458 19.4857 0.613636 19.4857H19.1363C19.2275 19.2239 19.3682 18.9805 19.5627 18.7816C20.244 18.0776 21.4773 18.0776 22.1646 18.7816C22.3587 18.9805 22.4995 19.2239 22.5908 19.4857H26.3864C26.7255 19.4857 27 19.7669 27 20.1143Z'
				fill='#BDBDCF'
			/>
		</svg>
	);
};
